'use client';
import GridContainer from 'components/containers/grid-container';

// Client component wrapper for GridContainer currently in use in the Exhibition detail page.
// The component is passed to ReadMoreLoader to render on the client, so it needs to be a client component
// Quick fix for MCR wing issue: DIGAPPDEV-3501
const GridContainerClient = (props) => {
	return <GridContainer {...props} />;
};

export default GridContainerClient;
